import * as React from 'react'

const Plus = (props: { className?: string }) => (
  <svg
    className={props.className}
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.27273 7.95455H13.5227C13.7773 7.95455 14 7.73182 14 7.47727V6.52273C14 6.26818 13.7773 6.04545 13.5227 6.04545H8.27273C8.08182 6.04545 7.95455 5.91818 7.95455 5.72727V0.477273C7.95455 0.222727 7.73182 0 7.47727 0H6.52273C6.26818 0 6.04545 0.222727 6.04545 0.477273V5.72727C6.04545 5.91818 5.91818 6.04545 5.72727 6.04545H0.477273C0.222727 6.04545 0 6.26818 0 6.52273V7.47727C0 7.73182 0.222727 7.95455 0.477273 7.95455H5.72727C5.91818 7.95455 6.04545 8.08182 6.04545 8.27273V13.5227C6.04545 13.7773 6.26818 14 6.52273 14H7.47727C7.73182 14 7.95455 13.7773 7.95455 13.5227V8.27273C7.95455 8.08182 8.08182 7.95455 8.27273 7.95455Z'
      fill='#fff'
    />
  </svg>
)

export default Plus



// WEBPACK FOOTER //
// ./src/components/icons/organizations/Plus.tsx